const initialState = {
  bannersResult: [],
  loading: false,
  error: null,
};

const CLEAR_DATA = 'CLEAR_DATA';
const LOAD_BANNERS = 'LOAD_BANNERS';
const LOAD_BANNERS_ERROR = 'LOAD_BANNERS_ERROR';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_BANNERS: {
      return {
        ...state,
        bannersResult: action.payload,
        loading: false,
        error: null,
      };
    }
    case LOAD_BANNERS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case CLEAR_DATA: {
      return initialState; // no need to spread
    }
    default:
      return state;
  }
}
